import React from 'react';

const Blog = () => {
  return <div>Blog Page</div>;
};

export default Blog;